<template>
  <div>
    <DashboardSales :outStandingSales="outStandingSales" />
    <v-layout row wrap my-4>
      <v-flex xs12 md12>
        <table width="100%" class='text-xs-center'>
          <thead>
            <tr>
              <th>Order Code</th>
              <th>Customer Name</th>
              <th>Sales Contact</th>
              <th>Remailning Balance</th>
              <th>Collected</th>
            </tr>
          </thead>
          <tbody v-if="orders.length">
            <tr v-for="(order, index) in orders" :key="index">
              <td>{{order.orderCode}}</td>
              <td>{{order.customerID.firstName}} {{order.customerID.lastName}}</td>
              <td v-if="order.updatedBy">{{order.updatedBy.firstName}} {{order.updatedBy.lastName}}</td>
              <td v-else-if="order.createdBy">{{order.createdBy.firstName}} {{order.createdBy.lastName}}</td>
              <td v-else>Online</td>
              <td>${{ getRemainingBalance(order) }}</td>
              <td><v-btn @click="markAsCollected(order)" color="grey" dark large class="mark-as-collected">Mark as collected</v-btn></td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5">No Records found</td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import DashboardSales from './DashboardSales.vue'
import OrderService from '@/services/OrderService'
export default {
  data: () => ({
    outStandingSales: '0k',
    orders: []
  }),
  mounted () {
    this.getInTransitOrders()
  },
  methods: {
    async getInTransitOrders () {
      let response = await OrderService.getInTransitOrders()
      for (let index = 0; index < response.data.order.length; index++) {
        const order = response.data.order[index]
        this.orders.push(order.orderID)
      }
    },
    getRemainingBalance (order) {
      let remaining = 0
      if (order.paidAmount) {
        remaining = order.subTotal - order.paidAmount
      }
      return remaining
    },
    async markAsCollected (order) {
      let response = await OrderService.markAsCollected(order._id)
      if (response.data.success === true) {
        this.orders = []
        this.getInTransitOrders()
      }
    }
  },
  components: {
    DashboardSales
  }
}
</script>

<style scoped>
th, td {
  padding: 5px;
  font-size: 20px;
}
.th {
  padding: 10px;
  font-weight: bold;
}
.mark-as-collected {
  background: #ea4d76 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AccountDashboard.vue